import React, { useEffect } from 'react'

// Define the type for the HOC props
export type ThemeName = 'admin' | 'staff' | 'ol' | 'client'

// HOC that sets the theme and renders the wrapped component
function withTheme<T extends object>(
  WrappedComponent: React.ComponentType<T>,
  themeName: ThemeName
) {
  return (props: T) => {
    const { ...restProps } = props

    useEffect(() => {
      // Set the theme attribute on the <html> element
      document.querySelector('html')?.setAttribute('data-theme', themeName)
    }, [themeName])

    // Render the wrapped component with the rest of the props
    return <WrappedComponent {...restProps} />
  }
}

export default withTheme
